/* NovaBreak 3.0 — app layer: search, mega menu, quick add, toasts, rails, countdowns, cart terms */
(function () {
  'use strict';

  var root = document.documentElement;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var moneyFmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
  window.nbMoney = function (cents) { return moneyFmt.format((cents || 0) / 100); };

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function lockScroll(on) { root.classList.toggle('nb-lock', !!on); }

  /* ---------------- Toast ---------------- */
  var toastEl, toastTimer;
  function toast(html, tone) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.dataset.tone = tone || 'ok';
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3800);
  }
  window.nbToast = toast;

  /* ---------------- Quick add ---------------- */
  function refreshCartBubble() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=cart-icon-bubble' : '/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (!html || !bubble) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : html;
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-nb-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast('<span>' + (res.json.description || res.json.message || 'Could not add that item.') + '</span>', 'error');
          return;
        }
        var cartPath = (window.routes && window.routes.cart_url) || '/cart';
        if (location.pathname === cartPath) { location.reload(); return; }
        window.nbCartAdded(res.json);
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nb-quick-add' }); } catch (err) {}
        }
      })
      .catch(function () { toast('<span>Network error — try again.</span>', 'error'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });


  /* ---------------- Add-to-cart peek (replaces redirect to /cart) ---------------- */
  var peekEl, peekTimer, peekPaused = false;
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function hidePeek() { if (peekEl) peekEl.classList.remove('is-show'); clearTimeout(peekTimer); }
  function armPeek() {
    clearTimeout(peekTimer);
    if (peekEl) { peekEl.classList.remove('is-timing'); void peekEl.offsetWidth; peekEl.classList.add('is-timing'); }
    peekTimer = setTimeout(function () { if (!peekPaused) hidePeek(); }, 6000);
  }
  window.nbCartAdded = function (item) {
    item = item || {};
    var items = item.items ? item.items : [item];
    var first = items[0] || {};
    var added = items.reduce(function (n, i) { return n + (i.quantity || 1); }, 0);
    refreshCartBubble().then(function () {
      var b = document.getElementById('cart-icon-bubble');
      if (b) { b.classList.remove('nb-bump'); void b.offsetWidth; b.classList.add('nb-bump'); }
    });
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!peekEl) {
          peekEl = document.createElement('div');
          peekEl.className = 'nb-peek';
          peekEl.setAttribute('role', 'status');
          peekEl.setAttribute('aria-live', 'polite');
          peekEl.addEventListener('mouseenter', function () { peekPaused = true; clearTimeout(peekTimer); peekEl.classList.remove('is-timing'); });
          peekEl.addEventListener('mouseleave', function () { peekPaused = false; armPeek(); });
          peekEl.addEventListener('focusin', function () { peekPaused = true; clearTimeout(peekTimer); peekEl.classList.remove('is-timing'); });
          peekEl.addEventListener('click', function (e) { if (e.target.closest('[data-nb-peek-close]')) hidePeek(); });
          document.body.appendChild(peekEl);
        }
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        var img = first.featured_image && first.featured_image.url ? first.featured_image.url : first.image;
        if (img && img.indexOf('?') === -1) img += '?width=160'; else if (img) img += '&width=160';
        var threshold = window.nbFreeShipCents || 20000;
        var sub = cart.items_subtotal_price || 0;
        var pct = Math.min(100, (sub / threshold) * 100);
        var left = threshold - sub;
        var fsText = left > 0 ? window.nbMoney(left) + ' away from free shipping' : 'Free shipping unlocked';
        var variant = first.variant_title && first.variant_title !== 'Default Title' ? ' · ' + esc(first.variant_title) : '';
        peekEl.innerHTML =
          '<div class="nb-peek__row">' +
            (img ? '<span class="nb-peek__img"><img src="' + esc(img) + '" alt=""></span>' : '') +
            '<div class="nb-peek__body">' +
              '<p class="nb-peek__label"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg>Added to cart' + (added > 1 ? ' (' + added + ')' : '') + '</p>' +
              '<p class="nb-peek__title">' + esc(first.product_title || first.title) + variant + '</p>' +
            '</div>' +
            '<button type="button" class="nb-peek__close" data-nb-peek-close aria-label="Dismiss"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
          '</div>' +
          '<div class="nb-peek__fs' + (left <= 0 ? ' is-done' : '') + '"><span>' + fsText + '</span><span class="nb-peek__track"><span style="width:' + pct.toFixed(1) + '%"></span></span></div>' +
          '<div class="nb-peek__actions">' +
            '<a class="nb-btn nb-btn--primary" href="' + cartUrl + '">View cart · ' + cart.item_count + '</a>' +
            '<button type="button" class="nb-btn nb-btn--ghost" data-nb-peek-close>Keep shopping</button>' +
          '</div>' +
          '<span class="nb-peek__timer" aria-hidden="true"></span>';
        peekEl.classList.add('is-show');
        armPeek();
      })
      .catch(function () { toast('<span><strong>Added to cart</strong></span><a href="/cart">View cart</a>', 'ok'); });
  };

  /* ---------------- PDP sticky buy bar ---------------- */
  (function () {
    var bar = document.querySelector('[data-nb-stickybuy]');
    if (!bar) return;
    var form = document.getElementById(bar.dataset.formId);
    var realBtn = form && form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var addBtn = bar.querySelector('[data-nb-sticky-add]');
    if (!realBtn || !addBtn) return;
    bar.hidden = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-show', show);
        root.classList.toggle('nb-has-stickybuy', show);
      }).observe(realBtn);
    }
    addBtn.addEventListener('click', function () { realBtn.click(); });
    function sync() {
      var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      addBtn.disabled = disabled && !realBtn.classList.contains('loading');
      var label = realBtn.querySelector('span');
      if (label && label.textContent.trim()) addBtn.textContent = label.textContent.trim();
      var price = document.querySelector('[id^="price-"] .price-item--last, [id^="price-"] .price-item--regular');
      var target = bar.querySelector('[data-nb-sticky-price]');
      if (price && target) target.textContent = price.textContent.trim();
    }
    new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true });
  })();

  /* ---------------- Search ---------------- */
  class NbSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-nb-search-input]');
      this.results = this.querySelector('[data-nb-search-results]');
      this.suggest = this.querySelector('[data-nb-search-suggest]');
      this.idle = this.querySelector('[data-nb-search-idle]');
      this.clearBtn = this.querySelector('[data-nb-search-clear]');
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.suggestUrl = this.dataset.suggestUrl || '/search/suggest.json';
      this.filters = new URLSearchParams();
      this.sort = '';
      this.ctrl = null;
      this.sctrl = null;

      var run = debounce(this.run.bind(this), 220);
      this.input.addEventListener('input', function () { this.toggleClear(); run(); }.bind(this));
      this.input.addEventListener('focus', function () { if (!this.term()) this.showIdle(true); }.bind(this));
      this.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        this.run();
        this.input.blur();
      }.bind(this));
      if (this.clearBtn) this.clearBtn.addEventListener('click', function () {
        this.input.value = '';
        this.filters = new URLSearchParams();
        this.sort = '';
        this.toggleClear();
        this.run();
        this.input.focus();
      }.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-nb-sort]')) { this.sort = e.target.value; this.fetchResults(); }
      }.bind(this));
      if (this.term()) { this.toggleClear(); this.run(); }
    }

    term() { return (this.input.value || '').trim(); }

    toggleClear() { if (this.clearBtn) this.clearBtn.hidden = !this.input.value; }

    showIdle(on) {
      if (!this.idle) return;
      if (this.dataset.context === 'overlay') { this.idle.hidden = !on; return; }
      this.idle.hidden = !on;
    }

    onClick(e) {
      var termBtn = e.target.closest('[data-nb-search-term]');
      if (termBtn) {
        e.preventDefault();
        this.input.value = termBtn.dataset.nbSearchTerm;
        this.toggleClear();
        this.run();
        return;
      }
      var chip = e.target.closest('[data-nb-filter-param]');
      if (chip) {
        var p = chip.dataset.nbFilterParam, v = chip.dataset.nbFilterValue;
        var values = this.filters.getAll(p);
        this.filters.delete(p);
        if (values.indexOf(v) > -1) values = values.filter(function (x) { return x !== v; });
        else values.push(v);
        values.forEach(function (x) { this.filters.append(p, x); }.bind(this));
        chip.classList.toggle('is-active');
        this.fetchResults();
        return;
      }
      var price = e.target.closest('[data-nb-price]');
      if (price) {
        var parts = price.dataset.nbPrice.split('-');
        var same = this.filters.get('filter.v.price.gte') === parts[0] && (this.filters.get('filter.v.price.lte') || '') === (parts[1] || '');
        this.filters.delete('filter.v.price.gte');
        this.filters.delete('filter.v.price.lte');
        if (!same) {
          this.filters.set('filter.v.price.gte', parts[0]);
          if (parts[1]) this.filters.set('filter.v.price.lte', parts[1]);
        }
        this.fetchResults();
      }
    }

    run() {
      var q = this.term();
      if (q.length < 2) {
        if (this.ctrl) this.ctrl.abort();
        this.results.hidden = true;
        this.results.innerHTML = '';
        this.suggest.hidden = true;
        this.showIdle(document.activeElement === this.input || this.dataset.context === 'overlay');
        this.classList.remove('has-results');
        return;
      }
      this.showIdle(false);
      this.fetchResults();
      this.fetchSuggest();
    }

    fetchResults() {
      var q = this.term();
      if (q.length < 2) return;
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      var params = new URLSearchParams(this.filters);
      params.set('q', q);
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
      if (this.sort) params.set('sort_by', this.sort);
      params.set('section_id', 'nb-search-results');
      this.classList.add('is-loading');
      this.results.hidden = false;
      fetch(this.searchUrl + '?' + params.toString(), { signal: this.ctrl.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sr = doc.querySelector('.nb-sr');
          this.results.innerHTML = sr ? sr.outerHTML : '';
          this.classList.add('has-results');
          this.markPrice();
        }.bind(this))
        .catch(function (err) { if (err.name !== 'AbortError') this.results.innerHTML = ''; }.bind(this))
        .finally(function () { this.classList.remove('is-loading'); }.bind(this));
    }

    markPrice() {
      var gte = this.filters.get('filter.v.price.gte'), lte = this.filters.get('filter.v.price.lte') || '';
      this.results.querySelectorAll('[data-nb-price]').forEach(function (b) {
        var parts = b.dataset.nbPrice.split('-');
        var on = gte === parts[0] && lte === (parts[1] || '');
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    fetchSuggest() {
      var q = this.term();
      if (this.sctrl) this.sctrl.abort();
      this.sctrl = new AbortController();
      var url = this.suggestUrl + '?q=' + encodeURIComponent(q) +
        '&resources[type]=collection,query&resources[limit]=6&resources[limit_scope]=each';
      fetch(url, { signal: this.sctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var res = (json.resources && json.resources.results) || {};
          var cols = res.collections || [], queries = (res.queries || []).filter(function (x) {
            return x.text.toLowerCase() !== q.toLowerCase();
          });
          if (!cols.length && !queries.length) { this.suggest.hidden = true; return; }
          var html = '<div class="nb-chiprow">';
          cols.forEach(function (c) {
            html += '<a class="nb-chip nb-chip--link" href="' + c.url + '"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>' + c.title + '</a>';
          });
          queries.slice(0, 4).forEach(function (s) {
            var t = document.createElement('span'); t.textContent = s.text;
            html += '<button type="button" class="nb-chip nb-chip--ghost" data-nb-search-term="' + t.innerHTML.replace(/"/g, '&quot;') + '">' + t.innerHTML + '</button>';
          });
          this.suggest.innerHTML = html + '</div>';
          this.suggest.hidden = false;
        }.bind(this))
        .catch(function () {});
    }
  }
  if (!customElements.get('nb-search')) customElements.define('nb-search', NbSearch);

  /* ---------------- Sheets: search overlay + mega menu ---------------- */
  var openSheet = null, lastFocus = null;

  function openSheetEl(el, focusSel) {
    if (!el) return;
    if (openSheet && openSheet !== el) closeSheet();
    lastFocus = document.activeElement;
    el.hidden = false;
    lockScroll(true);
    el.offsetWidth; // reflow for transition
    el.classList.add('is-open');
    openSheet = el;
    document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = focusSel ? el.querySelector(focusSel) : null;
    if (f) f.focus({ preventScroll: true });
  }

  function closeSheet() {
    var el = openSheet;
    if (!el) return;
    el.classList.remove('is-open');
    document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openSheet = null;
    lockScroll(false);
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.nbCloseSheet = closeSheet;

  document.addEventListener('click', function (e) {
    var openSearch = e.target.closest('[data-nb-search-open]');
    if (openSearch) {
      e.preventDefault();
      openSheetEl(document.getElementById('NbSearchOverlay'), '[data-nb-search-input]');
      return;
    }
    var menuBtn = e.target.closest('[data-nb-menu-toggle]');
    if (menuBtn) {
      e.preventDefault();
      var mega = document.getElementById('NbMega');
      if (openSheet === mega) closeSheet(); else openSheetEl(mega, '.nb-mega__close');
      return;
    }
    if (e.target.closest('[data-nb-search-close], [data-nb-sheet-close]')) {
      e.preventDefault();
      closeSheet();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openSheet) closeSheet();
    if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !openSheet &&
        !/input|textarea|select/i.test((document.activeElement || {}).tagName || '')) {
      var ov = document.getElementById('NbSearchOverlay');
      if (ov) { e.preventDefault(); openSheetEl(ov, '[data-nb-search-input]'); }
    }
  });

  /* ---------------- Mega menu panels ---------------- */
  class NbMega extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: 990px)');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.nb-mega__item'));
      this.items.forEach(function (item) {
        var btn = item.querySelector('[data-nb-mega-btn]');
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (this.mq.matches) this.activate(item);
          else this.toggle(item);
        }.bind(this));
        btn.addEventListener('mouseenter', function () { if (this.mq.matches) this.activate(item); }.bind(this));
        btn.addEventListener('focus', function () { if (this.mq.matches) this.activate(item); }.bind(this));
      }.bind(this));
      this.reset();
      this.mq.addEventListener('change', this.reset.bind(this));
    }
    reset() {
      this.items.forEach(function (i) { i.classList.remove('is-active'); var b = i.querySelector('[data-nb-mega-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); });
      if (this.mq.matches) {
        var first = this.items.find(function (i) { return i.querySelector('[data-nb-mega-btn]'); });
        if (first) this.activate(first);
      }
    }
    activate(item) {
      this.items.forEach(function (i) {
        var on = i === item;
        i.classList.toggle('is-active', on);
        var b = i.querySelector('[data-nb-mega-btn]');
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    toggle(item) {
      var on = !item.classList.contains('is-active');
      item.classList.toggle('is-active', on);
      var b = item.querySelector('[data-nb-mega-btn]');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
  }
  if (!customElements.get('nb-mega')) customElements.define('nb-mega', NbMega);

  /* ---------------- Collection quick filters (ajax via Dawn facets) ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-nb-facet-link]');
    if (!a || e.metaKey || e.ctrlKey) return;
    if (window.FacetFiltersForm && document.getElementById('ProductGridContainer')) {
      e.preventDefault();
      var params = new URL(a.href, location.origin).searchParams.toString();
      FacetFiltersForm.renderPage(params, null, true);
    }
  });

  /* ---------------- Rails (desktop arrows) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nb-rail-prev], [data-nb-rail-next]');
    if (!btn) return;
    var rail = btn.closest('.nb-rail');
    var track = rail && rail.querySelector('[data-nb-rail-track]');
    if (!track) return;
    var dir = btn.hasAttribute('data-nb-rail-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  function syncRailNav() {
    document.querySelectorAll('.nb-rail').forEach(function (rail) {
      var track = rail.querySelector('[data-nb-rail-track]');
      var nav = rail.querySelector('.nb-rail__nav');
      if (track && nav) nav.hidden = track.scrollWidth <= track.clientWidth + 4;
    });
  }
  syncRailNav();
  window.addEventListener('resize', debounce(syncRailNav, 150));
  window.addEventListener('load', syncRailNav);

  /* ---------------- Countdowns ---------------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  var nbPageLoaded = Date.now();
  function tickCountdowns() {
    var now = Date.now();
    document.querySelectorAll('[data-nb-countdown]').forEach(function (el) {
      var target = Number(el.dataset.nbCountdown) * 1000;
      if (!target) return;
      var d = Math.max(0, target - now);
      var days = Math.floor(d / 864e5), h = Math.floor((d % 864e5) / 36e5), m = Math.floor((d % 36e5) / 6e4), s = Math.floor((d % 6e4) / 1e3);
      el.textContent = d === 0 ? (el.dataset.doneText || 'Open') : (days > 0 ? days + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      if (d === 0 && !el.dataset.fired) {
        el.dataset.fired = '1';
        /* Only reload when the countdown actually ran out while the page was open (no reload loops). */
        if (el.hasAttribute('data-reload-on-zero') && target > nbPageLoaded) setTimeout(function () { location.reload(); }, 1500);
      }
    });
  }
  if (document.querySelector('[data-nb-countdown]')) { tickCountdowns(); setInterval(tickCountdowns, 1000); }

  /* ---------------- Local drop times ----------------
     <time data-nb-time="unix seconds" data-nb-fmt="full|time|date"> is printed in the store's time zone;
     rewrite it in the viewer's own zone so "1:30 PM PDT" reads "4:30 PM EDT" on the East Coast. */
  (function () {
    var els = document.querySelectorAll('[data-nb-time]');
    if (!els.length || !window.Intl) return;
    els.forEach(function (el) {
      var s = Number(el.getAttribute('data-nb-time')); if (!s) return;
      var d = new Date(s * 1000), f = el.getAttribute('data-nb-fmt') || 'time';
      try {
        var time = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
        if (f === 'date') el.textContent = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
        else if (f === 'full') el.textContent = d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' }) + ' \u00b7 ' + time;
        else el.textContent = time;
        el.title = 'Shown in your time zone';
      } catch (e) {}
    });
  })();

  /* ---------------- Break Zone: "Opening" self-check ----------------
     The hub renders [data-nb-poll] only for tagged customers whose window should be open but whose
     products aren't published yet (late scheduled publish or late window-swap Flow).
     Every ~5s (15s in a background tab) it fetches just the hub section. When that section no longer
     carries the marker, the drop changed state, so the page reloads once to show it.
     It stops at data-poll-until, then reloads once more so the page shows the final state. */
  (function () {
    var marker = document.querySelector('[data-nb-poll]');
    if (!marker || !window.fetch) return;
    var sectionId = marker.getAttribute('data-nb-poll');
    var until = Number(marker.getAttribute('data-poll-until')) * 1000;
    if (!sectionId || !until || until <= Date.now()) return;
    var busy = false, done = false;
    function finish() { if (done) return; done = true; location.reload(); }
    function check() {
      if (done) return;
      if (Date.now() >= until) { finish(); return; }
      if (busy) { schedule(); return; }
      busy = true;
      var url = location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&nb_t=' + Date.now();
      fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          busy = false;
          if (html && html.indexOf('data-nb-poll') === -1) { finish(); return; }
          schedule();
        })
        .catch(function () { busy = false; schedule(); });
    }
    function schedule() {
      var base = document.hidden ? 15000 : 5000;
      setTimeout(check, base + Math.floor(Math.random() * 1500)); /* jitter spreads the load */
    }
    schedule();
  })();

  /* ---------------- Cart: policy acknowledgement ---------------- */
  function syncTerms() {
    var box = document.querySelector('[data-nb-terms]');
    if (!box) return;
    var ok = box.checked;
    document.querySelectorAll('.nb-dyn-checkout').forEach(function (w) { w.classList.toggle('is-locked', !ok); });
  }
  document.addEventListener('change', function (e) { if (e.target.matches('[data-nb-terms]')) syncTerms(); });
  document.addEventListener('submit', function (e) {
    var box = document.querySelector('[data-nb-terms]');
    if (!box || box.checked) return;
    var submitter = e.submitter;
    if (e.target.id === 'cart' && submitter && submitter.name === 'checkout') {
      e.preventDefault();
      var wrap = box.closest('.nb-terms');
      if (wrap) { wrap.classList.remove('is-shake'); wrap.offsetWidth; wrap.classList.add('is-shake'); }
      box.focus();
    }
  }, true);
  document.addEventListener('click', function (e) {
    var lock = e.target.closest('.nb-dyn-checkout.is-locked');
    if (!lock) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = document.querySelector('.nb-terms');
    if (wrap) { wrap.classList.remove('is-shake'); wrap.offsetWidth; wrap.classList.add('is-shake'); }
  }, true);
  syncTerms();
  window.addEventListener('pageshow', syncTerms);

  /* ---------------- Recommendations: swap server fallback for Shopify recommendations ---------------- */
  document.querySelectorAll('[data-nb-recs-url]').forEach(function (box) {
    fetch(box.dataset.nbRecsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-nb-recs-grid]');
        var target = box.querySelector('[data-nb-recs-grid]');
        if (fresh && target && fresh.children.length >= 2) { target.innerHTML = fresh.innerHTML; syncRailNav(); }
        if (target && target.children.length === 0) box.hidden = true;
      })
      .catch(function () {});
  });
})();

/* NovaBreak 3.0 — copy-to-clipboard buttons (quest codes) */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nb-copy]');
    if (!btn) return;
    var text = btn.getAttribute('data-nb-copy');
    var label = btn.textContent;
    function done() { btn.textContent = btn.getAttribute('data-copied-text') || 'Copied'; setTimeout(function () { btn.textContent = label; }, 1800); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { window.prompt('Copy this code:', text); });
    } else {
      window.prompt('Copy this code:', text);
    }
  });
})();
